import {Component, input} from '@angular/core';

@Component({
  selector: 'app-circle-icon',
  styles: `
    :host {
      height: 8px;
      width: 8px;
      display: inline-block;
      line-height: 0;
    }

    svg {
      fill: #00900E;
    }

    .danger-color {
      fill: #D44C4C;
    }
  `,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none"
         [class.danger-color]="showDanger()">
      <circle cx="4" cy="4.21289" r="4"/>
    </svg>
  `,
  standalone: true
})
export class CircleIconComponent {

  showDanger = input(false);

}
